import useSWR, { SWRResponse } from "swr";
import { IUseBank } from "./types";
import { IBank } from "@portal/types/api/IBank";
import commonSwrConfig from "../commonSwrConfig";
import { useSession } from "@portal/auth/client/SessionProvider";
import { commonFetcher } from "../common/commonFetcher";

const useBank: IUseBank = () => {
  const { session, update } = useSession();

  const { data, isLoading, error }: SWRResponse<IBank, unknown> = useSWR(
    session?.centerId ? `/api/bank/${session?.centerId}` : null,
    commonFetcher<IBank>,
    commonSwrConfig(update),
  );

  return {
    data,
    error,
    isLoading,
  };
};

export default useBank;
